import { shape, string, number, arrayOf, oneOfType, func } from 'prop-types';

import { stringOrNumberPropTypes } from '~utils/propTypes';

export const addressPropTypes = shape({
  textAddress: string,
  apartmentDetails: string,
  kind: string,
  dispatchNote: string,
  latitude: stringOrNumberPropTypes,
  longitude: stringOrNumberPropTypes
});

export const addressProfilePropTypes = arrayOf(addressPropTypes);

export const userAddProptypes = shape({
  value: string,
  position: number
});

export const addressComponentPropTypes = shape({
  longName: string,
  shortName: string,
  types: arrayOf(string)
});

export const addressLocationPropTypes = shape({
  lat: oneOfType([func, string, number]).isRequired,
  lng: oneOfType([func, string, number]).isRequired
});

export const addressGeometryPropTypes = shape({
  location: addressLocationPropTypes,
  locationType: string,
  viewport: shape()
});

export const googleAddressPropTypes = shape({
  addressComponents: arrayOf(addressComponentPropTypes),
  formattedAddress: string,
  geometry: addressGeometryPropTypes,
  placeId: string,
  types: arrayOf(string)
});
